(function () {
    'use strict';

    angular
        .module('app')
        .controller('ForgottenPasswordController', ForgottenPasswordController);

    ForgottenPasswordController.$inject = ['$http', '$rootScope', '$scope', '$stateParams', '$state'];

    function ForgottenPasswordController($http, $rootScope, $scope, $stateParams, $state) {
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.send_email = send_email;
        vm.user_email = $stateParams.user_email;

        function init(){
            $rootScope.header_inverted = false;
            $rootScope.on_dashboard = false;
            $rootScope.dark_text_header = true;

        }

        function close(){
            if($rootScope.previousState && typeof $rootScope.previousState.name == 'string'){
                // if the previous state has been set in $transitions hook
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                $state.go('frontpage');
            }
        }

        function send_email(){
            vm.sending_email = true;
            return $http.post('/app/api/users/forgotten_password', {email: vm.email})
                .then(function(response){
                    vm.sending_email = false;
                    vm.email_has_been_sent = response.data.email_sent;
                });
        }
    }
})();